// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Search Bar Component */
search-bar {
  display: block;
}

.search-bar-container {
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: 0.75rem;
  background-color: var(--bg-main);
  height: 2.75rem;
  border: 1px solid transparent;
  transition: all var(--transition-normal);
}

.dark .search-bar-container {
  background-color: var(--bg-card);
}

.search-bar-container:focus-within {
  border-color: var(--text-muted);
}

.search-bar-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.75rem;
  color: var(--text-muted);
}

.search-bar-input {
  width: 100%;
  background: transparent;
  border: none;
  font-size: 0.875rem;
  color: var(--text-primary);
  padding: 0 0.75rem;
  height: 100%;
  box-shadow: none;
  outline: none;
}

/* Hide browser's native clear button for search input */
.search-bar-input::-webkit-search-cancel-button,
.search-bar-input::-webkit-search-decoration,
.search-bar-input::-webkit-search-results-button,
.search-bar-input::-webkit-search-results-decoration {
  -webkit-appearance: none;
  appearance: none;
  display: none;
}

.search-bar-input::placeholder {
  color: var(--text-muted);
}

.search-bar-input:focus {
  outline: none;
  box-shadow: none;
  border: none;
}

.search-bar-clear-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: all var(--transition-normal);
}

.search-bar-clear-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.dark .search-bar-clear-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Mobile Search Container */
.mobile-search-container {
  padding: 0 1.25rem 1rem;
  background-color: var(--bg-main);
  position: sticky;
  top: var(--mobile-header-height);
  z-index: 19;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/search-bar.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA,wDAAwD;AACxD;;;;EAIE,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;AACb","sourcesContent":["/* Search Bar Component */\nsearch-bar {\n  display: block;\n}\n\n.search-bar-container {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  border-radius: 0.75rem;\n  background-color: var(--bg-main);\n  height: 2.75rem;\n  border: 1px solid transparent;\n  transition: all var(--transition-normal);\n}\n\n.dark .search-bar-container {\n  background-color: var(--bg-card);\n}\n\n.search-bar-container:focus-within {\n  border-color: var(--text-muted);\n}\n\n.search-bar-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 0.75rem;\n  color: var(--text-muted);\n}\n\n.search-bar-input {\n  width: 100%;\n  background: transparent;\n  border: none;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n  padding: 0 0.75rem;\n  height: 100%;\n  box-shadow: none;\n  outline: none;\n}\n\n/* Hide browser's native clear button for search input */\n.search-bar-input::-webkit-search-cancel-button,\n.search-bar-input::-webkit-search-decoration,\n.search-bar-input::-webkit-search-results-button,\n.search-bar-input::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n  appearance: none;\n  display: none;\n}\n\n.search-bar-input::placeholder {\n  color: var(--text-muted);\n}\n\n.search-bar-input:focus {\n  outline: none;\n  box-shadow: none;\n  border: none;\n}\n\n.search-bar-clear-btn {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  margin-right: 0.5rem;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.search-bar-clear-btn:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.dark .search-bar-clear-btn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Mobile Search Container */\n.mobile-search-container {\n  padding: 0 1.25rem 1rem;\n  background-color: var(--bg-main);\n  position: sticky;\n  top: var(--mobile-header-height);\n  z-index: 19;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
